(function () {
  'use strict';

  var MAKE_PARAM = 'filter.p.m.custom.car_make';
  var MODEL_PARAM = 'filter.p.m.custom.car_model';
  var UNIVERSAL_VALUE = 'Universal';
  var DESKTOP_QUERY = '(min-width: 990px)';

  var root = document.querySelector('[data-lcm-header-garage]');

  if (!root || root.dataset.lcmInitialized === 'true') {
    return;
  }

  root.dataset.lcmInitialized = 'true';

  var desktopMedia = window.matchMedia(DESKTOP_QUERY);
  var details = root.querySelector('details');
  var pickerMount = root.querySelector('[data-lcm-header-garage-picker]');
  var changeButton = root.querySelector('[data-lcm-header-garage-change]');
  var clearButton = root.querySelector('[data-lcm-header-garage-clear]');
  var pickerSource = null;
  var quickFilter = null;
  var retryCount = 0;
  var MAX_RETRIES = 100;

  function getVehicle() {
    if (
      !window.LCMVehicle ||
      typeof window.LCMVehicle.getActive !== 'function'
    ) {
      return undefined;
    }

    return window.LCMVehicle.getActive();
  }

  function getVehicleName(vehicle) {
    if (!vehicle) {
      return '';
    }

    return [vehicle.make, vehicle.model]
      .map(function (part) {
        return String(part || '').trim();
      })
      .filter(Boolean)
      .join(' ');
  }

  function findGlobalPickerSource() {
    if (
      pickerSource &&
      document.documentElement.contains(pickerSource)
    ) {
      return pickerSource;
    }

    pickerSource = document.querySelector(
      '.shopify-section-group-header-group ' +
      '[data-lcm-vehicle-picker-source]'
    );

    return pickerSource;
  }

  function rememberQuickFilter() {
    if (
      quickFilter &&
      document.documentElement.contains(quickFilter)
    ) {
      return quickFilter;
    }

    var source = findGlobalPickerSource();

    if (source) {
      quickFilter = source.querySelector(
        'quick-filter[data-mode="filter"]'
      );
    }

    return quickFilter;
  }

  function mountPickerInGarage() {
    var filter = rememberQuickFilter();

    if (!filter || !pickerMount) {
      return false;
    }

    if (filter.parentNode !== pickerMount) {
      pickerMount.appendChild(filter);
    }

    return true;
  }

  function returnPickerToSource() {
    var source = findGlobalPickerSource();
    var filter = rememberQuickFilter();

    if (!source || !filter) {
      return;
    }

    if (filter.parentNode !== source) {
      source.appendChild(filter);
    }

    source.hidden = true;
    source.setAttribute('aria-hidden', 'true');
    source.style.setProperty('display', 'none', 'important');

    setPickerOpen(false);

    window.setTimeout(function () {
      window.dispatchEvent(
        new CustomEvent('lcm:vehiclechange', {
          detail: { reason: 'header-garage-responsive' }
        })
      );
    }, 0);
  }

  function setPickerOpen(open) {
    if (!pickerMount || !changeButton) {
      return;
    }

    pickerMount.hidden = !open;
    root.classList.toggle('is-picker-open', open);
    changeButton.setAttribute('aria-expanded', String(open));
    changeButton.textContent = open
      ? changeButton.dataset.labelClose
      : changeButton.dataset.labelOpen;
  }

  function closeGarage() {
    setPickerOpen(false);

    if (details) {
      details.open = false;
    }
  }

  function render() {
    var vehicle = getVehicle();

    if (typeof vehicle === 'undefined') {
      retryCount += 1;

      if (retryCount <= MAX_RETRIES) {
        window.setTimeout(render, 50);
      }

      return;
    }

    retryCount = 0;

    var emptyLabel = root.dataset.emptyLabel || 'Kies auto';
    var name = getVehicleName(vehicle) || emptyLabel;
    var triggerName = root.querySelector(
      '[data-lcm-header-garage-name]'
    );
    var panelName = root.querySelector(
      '[data-lcm-header-garage-panel-name]'
    );

    root.classList.toggle('has-vehicle', Boolean(vehicle));

    if (triggerName) {
      triggerName.textContent = name;
    }

    if (panelName) {
      panelName.textContent = name;
    }

    if (clearButton) {
      clearButton.hidden = !vehicle;
    }
  }

  function applyResponsiveLayout() {
    if (desktopMedia.matches) {
      mountPickerInGarage();
      render();
      return;
    }

    closeGarage();
    returnPickerToSource();
  }

  function getSelectedVehicle(filter) {
    if (!filter) {
      return null;
    }

    var makeSelect = filter.querySelector('select[data-index="1"]');
    var modelSelect = filter.querySelector('select[data-index="2"]');

    if (!makeSelect || !modelSelect) {
      return null;
    }

    var make = String(makeSelect.value || '').trim();
    var model = String(modelSelect.value || '').trim();

    if (!make || !model || model === UNIVERSAL_VALUE) {
      return null;
    }

    var makeOption = makeSelect.options[makeSelect.selectedIndex];
    var modelOption = modelSelect.options[modelSelect.selectedIndex];

    if (
      !makeOption ||
      makeOption.getAttribute('data-filter-name') !== MAKE_PARAM ||
      !modelOption ||
      modelOption.getAttribute('data-filter-name') !== MODEL_PARAM
    ) {
      return null;
    }

    return { make: make, model: model };
  }

  if (changeButton) {
    changeButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (!mountPickerInGarage()) {
        return;
      }

      var shouldOpen = pickerMount.hidden;

      setPickerOpen(shouldOpen);

      if (shouldOpen) {
        window.setTimeout(function () {
          var control = pickerMount.querySelector(
            '.nice-select, select, button, [tabindex="0"]'
          );

          if (control && typeof control.focus === 'function') {
            control.focus({ preventScroll: true });
          }
        }, 0);
      }
    });
  }

  if (clearButton) {
    clearButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.deselect === 'function'
      ) {
        window.LCMVehicle.deselect({ reason: 'header-garage' });
      }

      closeGarage();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.isCollectionUrl === 'function' &&
        window.LCMVehicle.isCollectionUrl(window.location.href) &&
        typeof window.LCMVehicle.getUnfilteredCollectionUrl === 'function'
      ) {
        window.location.assign(
          window.LCMVehicle.getUnfilteredCollectionUrl(
            window.location.href
          )
        );
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var submitButton = event.target.closest(
        '[data-lcm-header-garage] ' +
        'quick-filter[data-mode="filter"] .js-filter-submit'
      );

      if (!submitButton) {
        return;
      }

      var filter = submitButton.closest(
        'quick-filter[data-mode="filter"]'
      );
      var vehicle = getSelectedVehicle(filter);

      if (!vehicle) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.select === 'function'
      ) {
        window.LCMVehicle.select(vehicle, {
          reason: 'header-garage'
        });
      }

      closeGarage();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.isCollectionUrl === 'function' &&
        window.LCMVehicle.isCollectionUrl(window.location.href) &&
        typeof window.LCMVehicle.getFilteredCollectionUrl === 'function'
      ) {
        window.location.assign(
          window.LCMVehicle.getFilteredCollectionUrl(
            window.location.href,
            vehicle
          )
        );
      } else {
        render();
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    if (
      details &&
      details.open &&
      !root.contains(event.target)
    ) {
      closeGarage();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !details || !details.open) {
      return;
    }

    closeGarage();

    var summary = root.querySelector('summary');

    if (summary) {
      summary.focus();
    }
  });

  window.addEventListener('lcm:vehiclechange', function () {
    render();
  });

  if (typeof desktopMedia.addEventListener === 'function') {
    desktopMedia.addEventListener('change', applyResponsiveLayout);
  } else {
    desktopMedia.addListener(applyResponsiveLayout);
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(applyResponsiveLayout, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyResponsiveLayout,
      { once: true }
    );
  } else {
    applyResponsiveLayout();
  }
})();
